export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a la lista de contenedores"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Datos del contenedor"])},
          "title_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas"])},
          "total_number_org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Facturas pagadas"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to containers list"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Container data"])},
          "title_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoices"])},
          "total_number_org_invoices": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Invoices"])},
          "total_number_org_invoices_paid": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paid invoices"])}
        }
      }
    }
  })
}